import {
  GET_OTHER_FAILD,
  GET_OTHER_LOAD,
  GET_OTHER_SUCCESS,
  GET_ONE_OTHER,
} from "../constants/other";

const initialState = {
  others: [],
  other: {},
  isLoad: false,
  isError: false,
};

const otherReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_OTHER_SUCCESS:
      return {
        ...state,
        others: payload.others,
        isLoad: false,
      };
    case GET_OTHER_LOAD:
      return { ...state, isLoad: true };
    case GET_OTHER_FAILD:
      return {
        ...state,
        isLoad: false,
        isError: true,
      };
    case GET_ONE_OTHER:
      return { ...state, other: payload.result, isLoad: false };

    default:
      return state;
  }
};

export default otherReducers;
